// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"41e9d204f30949d5dd3c","532":"7d648493ad4ad5b45275","678":"9c8f58cb257d2e07e7f1","883":"875a9cd4834566a3a5ab"}[chunkId] + ".js";
};